import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex w-full flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-primary-500">
        <i className="ri-film-line text-4xl" />
      </span>
      <h1 className="mt-6 font-heading text-5xl font-black text-primary-500 md:text-7xl">404</h1>
      <h2 className="mt-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">页面不存在</h2>
      <p className="mt-2 max-w-md text-sm text-foreground-600">
        你访问的页面可能已被移除或地址有误：<span className="font-mono text-foreground-500">{location.pathname}</span>
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200"
        >
          <i className="ri-search-line" />
          去搜索
        </Link>
      </div>
    </div>
  );
}